/* eslint-disable react/prop-types */
import Image from "next/image";
import { useState, useEffect } from 'react';
import React from 'react';

function ProductImage({ img, productName, width = 250, height = 175, className = "mx-auto" }) {
  const fallbackSrc = "/images/no-image.jpg";
  const [imgSrc, setImgSrc] = useState(img?.src || fallbackSrc);

  // Update imgSrc if img?.src changes
  useEffect(() => {
    setImgSrc(img?.src || fallbackSrc);
  }, [img?.src]);

  return (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
        maxWidth: "100%",
        overflow: "hidden",
        position: "relative",
      }}
      className={className}
    >
      <Image
        src={imgSrc}
        alt={img?.alt || productName}
        title={productName || "Product image"}
        fill
        sizes={`(max-width: 768px) 100vw, (max-width: 1200px) 50vw, ${width}px`}
        style={{ objectFit: "cover" }}
        quality={80}
        onError={() => setImgSrc(fallbackSrc)}
        priority={false}
      />
    </div>
  );
}

export default React.memo(ProductImage);
